import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import BaseService from "../../../../../services/BaseService";
import Loader from "../../../../common/Loader";
import LeadService from "../../../../../services/LeadService";
import uploadImg from "../../../../../images/upload-img.png";

const AddLeadsModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		leadName: "",
		clientName: "",
		clientPhone: "",
		clientEmail: "",
		reference: "",
		attachmentUrl: "",
	});
	const [isAdd, setIsAdd] = useState(true);
	const [uploading, setUploading] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		if (!item || Object.keys(item).length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				leadName: item.leadName || "",
				clientName: item.clientName || "",
				clientPhone: item.clientPhone || "",
				clientEmail: item.clientEmail || "",
				reference: item.reference || "",
				attachmentUrl: item.attachmentUrl || "",
			});
		}
	}, [item]);

	const fileHandler = (e) => {
		const file = e.target.files[0];
		if (!file) return;
		setUploading(true);
		new BaseService()
			.postUpload(file)
			.then((res) => {
				if (res?.status === 200)
					setFormData((prev) => ({ ...prev, attachmentUrl: res?.data?.url }));
			})
			.finally(() => setUploading(false));
	};

	const submit = (e) => {
		e.preventDefault();
		const data = {
			leadName: formData.leadName,
			clientName: formData.clientName,
			clientPhone: formData.clientPhone,
			clientEmail: formData.clientEmail,
			reference: formData.reference,
		};
		if (!!formData.attachmentUrl)
			data["attachmentUrl"] = formData.attachmentUrl;
		setLoading(true);
		const leadService = new LeadService();
		const req = isAdd
			? leadService.create(data)
			: leadService.update(item.id, data);
		req
			?.then((res) => {
				if (res?.status === 201 || res?.status === 200) {
					toast.success(
						isAdd
							? Translate[lang]?.added_successfully || "Lead Added Successfully"
							: Translate[lang]?.updated_successfully ||
									"Lead Updated Successfully",
					);
					setShouldUpdate((prev) => !prev);
					setAddModal();
				}
			})
			.finally(() => setLoading(false));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={setAddModal}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.leads}
					</Modal.Title>
					<Button
						variant=""
						className="close"
						style={{
							right: lang === "en" ? "0" : "auto",
							left: lang === "ar" ? "0" : "auto",
						}}
						onClick={setAddModal}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.lead_name}
								type="text"
								placeholder={Translate[lang]?.lead_name}
								bsSize="lg"
								name="leadName"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang]?.field_required,
									},
								}}
								value={formData.leadName}
								onChange={(e) =>
									setFormData({ ...formData, leadName: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.client_name}
								type="text"
								placeholder={Translate[lang]?.client_name}
								bsSize="lg"
								name="clientName"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang]?.field_required,
									},
								}}
								value={formData.clientName}
								onChange={(e) =>
									setFormData({ ...formData, clientName: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.client_phone}
								type="text"
								placeholder={Translate[lang]?.client_phone}
								bsSize="lg"
								name="clientPhone"
								value={formData.clientPhone}
								onChange={(e) =>
									setFormData({ ...formData, clientPhone: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.client_email}
								type="text"
								placeholder={Translate[lang]?.client_email}
								bsSize="lg"
								name="clientEmail"
								value={formData.clientEmail}
								onChange={(e) =>
									setFormData({ ...formData, clientEmail: e.target.value })
								}
							/>
						</Col>
						<Col md={12}>
							<AvField
								label={Translate[lang]?.reference}
								type="text"
								placeholder={Translate[lang]?.reference}
								bsSize="lg"
								name="reference"
								value={formData.reference}
								onChange={(e) =>
									setFormData({ ...formData, reference: e.target.value })
								}
							/>
						</Col>
						<Col md={12} className="mt-3">
							<div className="form-group w-100">
								<label className="m-0">{Translate[lang]?.attachments}</label>
								<div className="image-placeholder">
									<div className="avatar-edit h-100">
										<input
											type="file"
											accept=".pdf"
											onChange={fileHandler}
											style={{ opacity: "0" }}
											className="d-block w-100 h-100 cursor-pointer"
											value=""
										/>
									</div>
									<div className="avatar-preview2 m-auto">
										<div id="imagePreview">
											{!uploading && (
												<img
													src={uploadImg}
													alt="icon"
													style={{ width: "80px", height: "80px" }}
												/>
											)}
											{uploading && <Loader />}
										</div>
									</div>
								</div>
							</div>
						</Col>
						{formData.attachmentUrl && (
							<Col md={2} className="mt-2">
								<div style={{ position: "relative" }}>
									<i
										className="la la-trash text-danger position-absolute cursor-pointer"
										style={{ top: "-9px" }}
										onClick={() =>
											setFormData({ ...formData, attachmentUrl: "" })
										}
									/>
									<a
										href={formData.attachmentUrl}
										target="_blank"
										rel="noreferrer">
										<i
											className="la la-file-pdf"
											style={{ fontSize: "5rem" }}
										/>
									</a>
								</div>
							</Col>
						)}
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={setAddModal} variant="danger light">
						{Translate[lang]?.close}
					</Button>
					<Button
						variant="primary"
						type="submit"
						disabled={loading || uploading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddLeadsModal;
